<template>
    <div v-bind:class="isBackgroundImage == 'true' ? 'parallax-with-image':''">
        <div class="footer-wrapper" v-bind:class="isBackgroundImage == 'false' ? 'mobile-footer-image':''">
            <div id="footer-md" class="row h-100 pl-5 pr-5">
                <div class="col align-self-end">
                    <div class="row">
                        <div class="col-2">
                            <h6 class="lato-bold">Navigation</h6>
                        </div>
                        <div class="col-2 offset-2">
                            <h6 class="lato-bold">Our Site</h6>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-2">
                            <ul>
                                <li>
                                    <a v-on:click="setActiveRoute('welcome-wrapper')">
                                        <small class="lato-light" v-bind:class="currentTab === 'welcome-wrapper' ? 'active':''">Welcome</small>
                                    </a>
                                </li>
                                <li>
                                    <a class="text-white" v-on:click="setActiveRoute('commission-wrapper')">
                                        <small class="lato-light" v-bind:class="currentTab === 'commission-wrapper' ? 'active':''">Commission</small>
                                    </a>
                                </li>
                                <li>
                                    <a class="text-white" v-on:click="setActiveRoute('whyus')">
                                        <small class="lato-light" v-bind:class="currentTab === 'whyus' ? 'active':''">Why Us</small>
                                    </a>
                                </li>

                            </ul>
                        </div>
                        <div class="col-2">
                            <ul>
                                <li>
                                    <a href="/faq" class="text-white">
                                        <small class="lato-light" v-bind:class="currentTab === 'faq' ? 'active':''">F.A.Q</small>
                                    </a>
                                </li>
                                <li>
                                    <a class="text-white" v-on:click="setActiveRoute('contactus')">
                                        <small class="lato-light" v-bind:class="currentTab === 'contactus' ? 'active':''">Contact Us</small>
                                    </a>
                                </li>
                                <li>
                                    <a href="/terms-and-conditions" class="text-white">
                                        <small class="lato-light" v-bind:class="currentTab === 'terms-and-conditions' ? 'active':''">Terms & Conditions</small>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div class="col-2">
                            <ul>
                                <li>
                                    <a href="https://games.bitcoin.com/" target="_blank" class="text-white">
                                        <small class="lato-light">Games.Bitcoin.com</small>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://cashgames.bitcoin.com/" target="_blank" class="text-white">
                                        <small class="lato-light">CashGames.Bitcoin.com</small>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div class="col-6 align-self-center">
                            <a href="https://t.me/bitcoincomgames" target="_blank">
                                <img class="float-right p-1 custom-img-height" src="@/assets/telegram.svg">
                            </a>
                            <a href="https://twitter.com/bitcoincomgames" target="_blank">
                                <img class="float-right p-1 custom-img-height" src="@/assets/twitter.svg">
                            </a>
                            <a href="https://www.facebook.com/BitcoincomGames" target="_blank">
                                <img class="float-right p-1 custom-img-height" src="@/assets/facebook.svg">
                            </a>
                            <a width="139" height="26" href="https://www.askgamblers.com" target="_blank">
                              <img class="float-right p-1 mr-2" src="@/assets/askgamblers-logo.svg">
                            </a>
                        </div>
                        <div class="col-12 mt-3">
                            <a class="btn btn-primary" href="skype:live:.cid.cd2d823c98c57a22?chat">
                                Connect via Skype&nbsp;&nbsp;<img class="p-1 custom-img-height" src="@/assets/skype.png" />
                            </a>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 pb-2">
                            <small class="float-right text-white lato-light">&#169; Bitcoin.com</small>
                        </div>
                    </div>
                </div>
            </div>
            <div id="footer-sm" class="row h-100 pl-5 pr-5">
                <div class="col align-self-end pl-3">
                    <div class="row">
                        <div class="col-12 p-0">
                            <h6 class="lato-bold">Navigation</h6>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6 p-0">
                            <ul>
                                <li>
                                    <a v-on:click="setActiveRoute('welcome-wrapper')">
                                        <small class="lato-light" v-bind:class="currentTab === 'welcome-wrapper' ? 'active':''">Welcome</small>
                                    </a>
                                </li>
                                <li>
                                    <a class="text-white" v-on:click="setActiveRoute('commission-wrapper')">
                                        <small class="lato-light" v-bind:class="currentTab === 'commission-wrapper' ? 'active':''">Commission</small>
                                    </a>
                                </li>
                                <li>
                                    <a class="text-white" v-on:click="setActiveRoute('whyus')">
                                        <small class="lato-light" v-bind:class="currentTab === 'whyus' ? 'active':''">Why Us</small>
                                    </a>
                                </li>

                            </ul>
                        </div>
                        <div class="col-6">
                            <ul>
                                <li>
                                    <a href="/faq" class="text-white">
                                        <small class="lato-light" v-bind:class="currentTab === 'faq' ? 'active':''">F.A.Q</small>
                                    </a>
                                </li>
                                <li>
                                    <a class="text-white"  v-on:click="setActiveRoute('contactus')">
                                        <small class="lato-light" v-bind:class="currentTab === 'contactus' ? 'active':''">Contact Us</small>
                                    </a>
                                </li>
                                <li>
                                    <a href="/terms-and-conditions" class="text-white">
                                        <small class="lato-light" v-bind:class="currentTab === 'terms-and-conditions' ? 'active':''">Terms & Conditions</small>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="row pt-3">
                        <div class="col-12 p-0">
                            <h6 class="lato-bold">Our Site</h6>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 p-0">
                            <ul>
                                <li>
                                    <a href="https://games.bitcoin.com/" target="_blank" class="text-white">
                                        <small class="lato-light">Games.Bitcoin.com</small>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://cashgames.bitcoin.com/" target="_blank" class="text-white">
                                        <small class="lato-light">CashGames.Bitcoin.com</small>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="row pt-4 justify-content-center">
                        <div class="col-12 align-self-center mb-5 mt-5 text-center">
                            <a href="https://www.askgamblers.com" target="_blank">
                              <img src="@/assets/askgamblers-logo.svg">
                            </a>
                        </div>
                        <div class="col-12 align-self-center text-center">
                            <a href="https://t.me/bitcoincomgames" target="_blank">
                                <img class="p-1 custom-img-height" src="@/assets/telegram.svg">
                            </a>
                            <a href="https://twitter.com/bitcoincomgames" target="_blank">
                                <img class="p-1 custom-img-height" src="@/assets/twitter.svg">
                            </a>
                            <a href="https://www.facebook.com/BitcoincomGames" target="_blank">
                                <img class="p-1 custom-img-height" src="@/assets/facebook.svg">
                            </a>
                        </div>
                        <div class="col-8 text-center mt-3">
                            <a class="btn btn-primary w-100" href="skype:live:.cid.cd2d823c98c57a22?chat">
                                Connect via Skype&nbsp;&nbsp;&nbsp;&nbsp;<img class="p-1" height="40" src="@/assets/skype.png" />
                            </a>
                        </div>
                    </div>
                    <div class="row justify-content-center pt-3 pb-3">
                        <div class="col-12 text-center">
                            <small class="text-white lato-light">&#169; Bitcoin.com</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {doScroll} from '../assets/js/scroll';
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: "Footer",
        props: ['isBackgroundImage'],
        computed: mapGetters([
            'currentTab'
        ]),
        methods: {
            ...mapActions([
                'setActiveTab',
            ]),
            doScroll,
            setActiveRoute: function (id,isClose = false) {
                this.setActiveTab(id);
                this.doScroll(id, isClose);
            }
        }
    }
</script>

<style scoped>
    @media (min-width: 576px) {
        .footer-wrapper {
            height: 30vh;
            background-image: url('~@/assets/footer.svg');
            background-repeat: no-repeat;
            background-position: center bottom;
            background-size: 100% 100%;
        }
        .custom-img-height {
            height: calc(1rem + 4vmin) !important;
        }
        #footer-sm {
            display: none;
        }

        h6 {
            color: white;
            font-size: calc(0.7rem + 1vmin);
        }

        .parallax-with-image {
            /* The image used */
            background-image: url('~@/assets/home.png');

            /* Full height */

            /* Create the parallax scrolling effect */
            background-attachment: fixed;
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
        }
        .mobile-footer-image{
        }
    }
    @media (max-width: 576px) {
        .footer-wrapper {
            padding-top: 3rem !important;
        }

        .mobile-footer-image {
            background-image: url('~@/assets/mobile-footer.svg');
            background-repeat: no-repeat;
            background-position: center bottom;
            background-size: 100% 100%;
        }

        .custom-img-height {
            height: calc(1rem + 15vmin);
        }

        #footer-md {
            display: none;
        }

        h6 {
            color: white;
            font-size: calc(0.7rem + 2vmin);
        }

        .parallax-with-image {
            /* The image used */
            background-image: url('~@/assets/home.png');

            /* Full height */

            /* Create the parallax scrolling effect */
            background-attachment: fixed;
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
            background-color: rgb(28, 80, 87);
        }
    }

    ul {
        list-style-type: none;
        margin: 0px;
        padding: 0px;
    }

    li {
        color: white;
    }

    .active {
        color: #00C58A;
    }

    a:hover {
        cursor: pointer;
    }

    small {
        font-size: 0.85rem;
    }

    .btn.btn-primary {
        background-color: rgba(89, 194, 142, 1);
        border: rgba(89, 194, 142, 1);
    }

</style>
